import { toast } from "react-toastify";
import { publicInstance } from "../../axios";

import {
    CLEAR_SEO,
    GET_SEO_FAILURE,
    GET_SEO_START,
    GET_SEO_SUCCESS,
    UPDATE_SEO,
} from "../constants";

export const getSeoData = () => (dispatch) => {
  dispatch({
    type: GET_SEO_START,
  });

  publicInstance
    .get(`get-seo`)
    .then((res) => {
      if (res.data && res.data.status) {
       console.log(res.data.data);
        dispatch({
          type: GET_SEO_SUCCESS,
          payload: res.data.data || [],
        });

        return res.data.data;
      } else {
        dispatch({
          type: GET_SEO_FAILURE,
          payload: [],
        });

        return [];
      }
    })
    .catch((error) => {
      dispatch({
        type: GET_SEO_FAILURE,
        payload: [],
      });
      return [];
    });
};



export const updateSeoData =  (data) => (dispatch) => {
  dispatch({
    type: UPDATE_SEO,
    payload: data,
  });
};
